import {
  GSpreadComponent,
  MinimumFaceIncrementComponent,
  MinimumInvestmentComponent,
  OfferAmountComponent,
} from "@goodfill/domain-properties-components";
import { useTranslation } from "react-i18next";
import { Field } from "../../../../ui-components";
import { PricedBond } from "../../PricedBond";
import { MoreAboutBox } from "./MoreAboutBox";

export const BondDetailMoreOnTheOffer = ({
  pricedBond,
  className,
}: { pricedBond: PricedBond; className?: string }) => {
  const { t } = useTranslation();

  return (
    <MoreAboutBox title="More on the Offer" className={className}>
      <div className="flex flex-col gap-8">
        <div className="grid grid-cols-2 gap-8">
          <Field label={"Offer G-Spread"} textAlign="left" labelClassName="whitespace-unset-important">
            <GSpreadComponent value={pricedBond.askGSpread} />
          </Field>
          <Field label={"Offer Size"} textAlign="left" labelClassName="whitespace-unset-important">
            <OfferAmountComponent value={pricedBond.bidAmount} />
          </Field>
        </div>
        <Field label={t("bond.minimumPiece")} labelClassName="whitespace-unset-important">
          <MinimumInvestmentComponent value={pricedBond.minimumPiece.amount} />
        </Field>
        <Field label={t("bond.minimumIncrement")} labelClassName="whitespace-unset-important">
          <MinimumFaceIncrementComponent value={pricedBond.minimumIncrement.amount} />
        </Field>
      </div>
    </MoreAboutBox>
  );
};
